import { ReplacementMotive } from './replacement-motive.interface';
import { ReplacementMotiveService } from './replacement-motive.service';
const service = new ReplacementMotiveService();

export interface ReplacementMotiveState {
   terminationMotives: Array<ReplacementMotive>;
   suspensionMotives: Array<ReplacementMotive>;
}

const state: ReplacementMotiveState = {
   terminationMotives: [],
   suspensionMotives: [],
};

const getters = {
   terminationMotives(state: ReplacementMotiveState) {
      return state.terminationMotives;
   },
   suspensionMotives(state: ReplacementMotiveState) {
      return state.suspensionMotives;
   },
};

const mutations = {
   SET_TERMINATION_MOTIVES(state: ReplacementMotiveState, terminationMotives: Array<ReplacementMotive>) {
      state.terminationMotives = terminationMotives;
   },
   SET_SUSPENSION_MOTIVES(state: ReplacementMotiveState, suspensionMotives: Array<ReplacementMotive>) {
      state.suspensionMotives = suspensionMotives;
   },
};

const actions = {
   async getTerminationReasons(context: any) {
      return await service.getReplacementMotives('termination').then((response) => {
         context.commit('SET_TERMINATION_MOTIVES', response);
         return response;
      });
   },
   async getSuspensionReasons(context: any) {
      return await service.getReplacementMotives('suspension').then((response) => {
         context.commit('SET_SUSPENSION_MOTIVES', response);
         return response;
      });
   },
};

export default {
   namespaced: true,
   state,
   getters,
   mutations,
   actions,
};
